import { useTranslation } from 'react-i18next';
import { Quote } from 'lucide-react';

export function TestimonialsSection() {
  const { t } = useTranslation();

  const testimonials = [
    { quote: t('landing.testimonials.quote1'), name: t('landing.testimonials.name1'), role: t('landing.testimonials.role1') },
    { quote: t('landing.testimonials.quote2'), name: t('landing.testimonials.name2'), role: t('landing.testimonials.role2') },
    { quote: t('landing.testimonials.quote3'), name: t('landing.testimonials.name3'), role: t('landing.testimonials.role3') },
  ];

  return (
    <section className="py-20" style={{ background: 'linear-gradient(180deg, #1A1F3C 0%, #0F1828 100%)' }}>
      <div className="container">
        <h2 className="mb-12 text-center text-3xl font-bold tracking-tight text-white md:text-4xl">
          {t('landing.testimonials.headline')}
        </h2>

        <div className="mx-auto max-w-5xl grid gap-6 md:grid-cols-3">
          {testimonials.map((tm, i) => (
            <div key={i} className="rounded-xl border border-white/10 bg-white/5 p-6 backdrop-blur-sm flex flex-col">
              <Quote className="h-8 w-8 text-[#4F6CFF]/40 mb-4" />
              <p className="text-white/80 text-sm leading-relaxed flex-1 mb-6">"{tm.quote}"</p>
              <div>
                <p className="font-semibold text-white text-sm">{tm.name}</p>
                <p className="text-white/50 text-xs">{tm.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
